import React from 'react';
import PropTypes from 'prop-types';

const CNAME = 'OverlappingValueProps';

const OverlappingValuePropsItem = ({ title, blurb }) =>
  (<li className={`${CNAME}__item`}>
    <strong className={`${CNAME}__title`}>{title}</strong>
    <span className={`${CNAME}__blurb`}>{blurb}</span>
  </li>
  );

OverlappingValuePropsItem.propTypes = {
  title: PropTypes.string,
  blurb: PropTypes.string
};

OverlappingValuePropsItem.defaultProps = {
  title: '',
  blurb: ''
};

export default OverlappingValuePropsItem;
